import { useState } from "react";
import { Phone } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useApp } from "@/context/AppContext";

export function WaIcon({ size = 20 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
      <path d="M17.5 14.4c-.3-.15-1.7-.84-1.97-.94-.26-.1-.46-.15-.65.15-.2.3-.75.94-.92 1.13-.17.2-.34.22-.63.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.6.13-.14.3-.34.44-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.65-1.57-.9-2.15-.24-.57-.48-.49-.65-.5h-.56c-.2 0-.5.07-.77.37-.26.3-1 .98-1 2.4 0 1.4 1.03 2.76 1.17 2.95.15.2 2.02 3.08 4.9 4.32.68.3 1.22.47 1.63.6.69.22 1.31.19 1.8.11.55-.08 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.56-.34zM12 2C6.48 2 2 6.48 2 12c0 1.77.46 3.43 1.27 4.87L2 22l5.25-1.38A9.94 9.94 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z" />
    </svg>
  );
}

export function ContactChooser({ type, side = "bottom", children }) {
  const { t, siteInfo } = useApp();
  const contacts = siteInfo.contacts || [];
  const [open, setOpen] = useState(false);
  const href = (c) =>
    type === "wa" ? `https://wa.me/${(c.phone || "").replace(/[^0-9]/g, "")}` : `tel:${(c.phone || "").replace(/\s/g, "")}`;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent side={side} align="center" sideOffset={8} className="w-72 p-2 rounded-none border-slate-200 shadow-xl" data-testid={`${type}-chooser`}>
        <div className="px-2 pt-1 pb-2 text-[11px] font-semibold uppercase tracking-widest text-slate-400">{t.contact.choose}</div>
        <div className="space-y-1">
          {contacts.map((c) => (
            <a
              key={c.phone}
              href={href(c)}
              {...(type === "wa" ? { target: "_blank", rel: "noreferrer" } : {})}
              onClick={() => setOpen(false)}
              data-testid={`${type}-option-${(c.phone || "").replace(/[^0-9]/g, "")}`}
              className="flex items-center gap-3 px-3 py-2.5 hover:bg-slate-100 transition-colors"
            >
              <span className={`flex h-9 w-9 items-center justify-center shrink-0 text-white ${type === "wa" ? "bg-wa" : "bg-brand"}`}>
                {type === "wa" ? <WaIcon size={16} /> : <Phone size={15} />}
              </span>
              <span>
                <span className="block font-semibold text-sm text-brand">{c.name}</span>
                <span className="block text-xs text-slate-500">{c.phone}</span>
              </span>
            </a>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
